import { Link, useParams } from "react-router-dom";
import { articles } from "./data";
import Nav from "../components/Nav";
import ContactUs from "../components/ContactUs";
import Footer from "../components/Footer";
import "../styling/style.css";

export default function BlogArticle() {
  // Grab the :slug parameter from the URL
  const { slug } = useParams();

  // Find the matching article
  const article = articles.find((a) => a.slug === slug);

  // Fallback 404 if the URL doesn't match an article
  if (!article) {
    return (
      <div style={{ textAlign: "center", padding: "100px" }}>
        <h2>Article not found</h2>
        <Link to="/blog">Return to blog</Link>
      </div>
    );
  }

  return (
    <div className="single-article-page" w>
      <Nav />
      <section className="article">
        <Link to="/blog" className="back-link">
          <span>{"<-"}</span>
          <span>{"Back"}</span>
        </Link>
        <img src={article.image} alt={article.title} className="hero-image" />
        <h1 className="article-title">{article.title}</h1>
        <div
          className="rich-text"
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
      </section>
      <ContactUs />
      <Footer />
    </div>
  );
}
